/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Corrections_LabelInputs */

const en_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrections`)
};

const fr_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrections`)
};

const de_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korrekturen`)
};

const it_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correzioni`)
};

const ru_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исправления`)
};

const es_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correcciones`)
};

const zh_cn2_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更正`)
};

const ja_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂正`)
};

const hi_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुधार`)
};

const pt_pt2_spellcheck_corrections_label = /** @type {(inputs: Spellcheck_Corrections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correções`)
};

/**
* | output |
* | --- |
* | "Corrections" |
*
* @param {Spellcheck_Corrections_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_corrections_label = /** @type {((inputs?: Spellcheck_Corrections_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Corrections_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_corrections_label(inputs)
	if (locale === "de") return de_spellcheck_corrections_label(inputs)
	if (locale === "it") return it_spellcheck_corrections_label(inputs)
	if (locale === "ru") return ru_spellcheck_corrections_label(inputs)
	if (locale === "es") return es_spellcheck_corrections_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_corrections_label(inputs)
	if (locale === "ja") return ja_spellcheck_corrections_label(inputs)
	if (locale === "hi") return hi_spellcheck_corrections_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_corrections_label(inputs)
	return en_spellcheck_corrections_label(inputs)
});